import * as i0 from '@angular/core';
import { Input, ViewEncapsulation, Component, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';

const imageSizes = ['xs', 'sm', 'md', 'lg', 'xl', 'full'];
class E11ImageComponent {
    constructor() {
        this.imageFit = 'contain';
        this.shape = 'square';
        this.background = false;
    }
    set width(width) {
        this._width = `w-${width}`;
    }
    set height(width) {
        this._height = `h-${width}`;
    }
    set size(size) {
        this._height = `h-${size}`;
        this._width = `w-${size}`;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11ImageComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: E11ImageComponent, selector: "e11-image", inputs: { imageUrl: "imageUrl", altText: "altText", imageFit: "imageFit", shape: "shape", width: "width", height: "height", size: "size", background: "background", contentClassOverrides: "contentClassOverrides", containerClassOverrides: "containerClassOverrides" }, ngImport: i0, template: "<div\n  class=\"e11-image-container {{ _width }} {{ _height }} {{ containerClassOverrides }}\"\n  [ngClass]=\"{\n    'e11-bg-gray-300 e11-flex e11-items-center e11-justify-center': !imageUrl,\n    'e11-bg-white': background,\n    'e11-rounded-md': shape === 'rounded',\n    'e11-rounded-full': shape === 'circular'\n  }\"\n>\n  <span class=\"material-icons-outlined md-48\" *ngIf=\"!imageUrl\"> image </span>\n  <img\n    *ngIf=\"imageUrl\"\n    class=\"e11-image e11-w-full e11-h-full {{ contentClassOverrides }}\"\n    [ngClass]=\"{\n      'e11-rounded-md': shape === 'rounded',\n      'e11-rounded-full': shape === 'circular',\n      'e11-object-contain': imageFit === 'contain',\n      'e11-object-cover': imageFit === 'cover'\n    }\"\n    src=\"{{ imageUrl }}\"\n    alt=\"{{ altText }}\"\n  />\n</div>\n", styles: [""], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11ImageComponent, decorators: [{
            type: Component,
            args: [{ selector: 'e11-image', encapsulation: ViewEncapsulation.None, template: "<div\n  class=\"e11-image-container {{ _width }} {{ _height }} {{ containerClassOverrides }}\"\n  [ngClass]=\"{\n    'e11-bg-gray-300 e11-flex e11-items-center e11-justify-center': !imageUrl,\n    'e11-bg-white': background,\n    'e11-rounded-md': shape === 'rounded',\n    'e11-rounded-full': shape === 'circular'\n  }\"\n>\n  <span class=\"material-icons-outlined md-48\" *ngIf=\"!imageUrl\"> image </span>\n  <img\n    *ngIf=\"imageUrl\"\n    class=\"e11-image e11-w-full e11-h-full {{ contentClassOverrides }}\"\n    [ngClass]=\"{\n      'e11-rounded-md': shape === 'rounded',\n      'e11-rounded-full': shape === 'circular',\n      'e11-object-contain': imageFit === 'contain',\n      'e11-object-cover': imageFit === 'cover'\n    }\"\n    src=\"{{ imageUrl }}\"\n    alt=\"{{ altText }}\"\n  />\n</div>\n" }]
        }], propDecorators: { imageUrl: [{
                type: Input
            }], altText: [{
                type: Input
            }], imageFit: [{
                type: Input
            }], shape: [{
                type: Input
            }], width: [{
                type: Input
            }], height: [{
                type: Input
            }], size: [{
                type: Input
            }], background: [{
                type: Input
            }], contentClassOverrides: [{
                type: Input
            }], containerClassOverrides: [{
                type: Input
            }] } });

class E11ImageModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11ImageModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: E11ImageModule, declarations: [E11ImageComponent], imports: [CommonModule], exports: [E11ImageComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11ImageModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11ImageModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [E11ImageComponent],
                    imports: [CommonModule],
                    exports: [E11ImageComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { E11ImageComponent, E11ImageModule, imageSizes };
